module.exports = __webpack_public_path__ + "img/left-to-line.d12ab860.svg";